import React from 'react';
import { useTranslation } from 'react-i18next';
import { useItemMarket } from '../context/ItemMarketContext';
import { useGameFabPulse } from '../hooks/useGameFabPulse';
import './GameFab.css';

const ItemMarketButton = () => {
  const { t } = useTranslation('gameData');
  const { openMarket } = useItemMarket();
  const pulse = useGameFabPulse();
  const title = t('itemMarketTitle');

  return (
    <button
      type="button"
      className={`game-fab game-fab--left${pulse ? ' game-fab-pulse' : ''}`}
      onClick={openMarket}
      aria-label={title}
      title={title}
    >
      <img src="/image/menu/nesne-market.png" alt="" className="game-fab__icon" draggable={false} />
    </button>
  );
};

export default ItemMarketButton;
